/* tslint:disable:object-literal-shorthand */
import {EventEmitter, Injectable, Output} from '@angular/core';
import {Observable, of} from 'rxjs';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ExgOverlayService {

  isOpen = false;
  componentName = '';

  onAction: EventEmitter<any> = new EventEmitter();
  onClose: EventEmitter<void> = new EventEmitter();

  // tslint:disable-next-line:no-output-native
  @Output()
  change: EventEmitter<boolean> = new EventEmitter();
  initialize: EventEmitter<string> = new EventEmitter();
  update: EventEmitter<any> = new EventEmitter();
  toggled: EventEmitter<any> = new EventEmitter<any>();


  public forceToggleEvent = false;

  // Widget Modal
  show(componentName: string, data: any, forceToggleEvent: boolean = false): Observable<any> {
    console.log("INIT");
    console.log(componentName);
    this.forceToggleEvent = forceToggleEvent;
    if (!this.isOpen) {

      this.componentName = componentName;
      this.initialize.emit(this.componentName);
      this.update.emit(data);

      this.isOpen = true;
      this.change.emit(this.isOpen);

      const obs = new Observable((observer) => {
        this.onAction.subscribe((args: any) => {
          observer.next(args);
          observer.complete();
          this.isOpen = false;
          this.change.emit(this.isOpen);
        });
        this.onClose.subscribe((args: any) => {
          observer.next(undefined);
          observer.complete();
          this.isOpen = false;
          this.change.emit(this.isOpen);
        });
      });

      return obs.pipe(take(1));
    }
    return of();
  }

  action(args: any): void {
    this.onAction.emit(args);
  }

  close(): void {
    this.onClose.emit();
  }






}
